/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1HIcon24Regular = forwardRef('ArrowDim1HIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M7.53 5.97a.75.75 0 0 1 0 1.06l-4.22 4.22H20.69l-4.22-4.22a.75.75 0 0 1 1.061-1.06l4.44 4.44a2.25 2.25 0 0 1 0 3.181l-4.44 4.44a.75.75 0 0 1-1.06-1.061l4.22-4.22H3.31l4.22 4.22a.75.75 0 1 1-1.06 1.06l-4.44-4.439a2.25 2.25 0 0 1 0-3.182l4.44-4.44a.75.75 0 0 1 1.06 0Z" })));
});
